<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0)">Finance</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Refund Request</li>
              </ol>
            </nav>
            <div class="content-header-info">
              <div class="col-sm-12 cRow">
                <button
                  v-if="isAllowToCreate"
                  class="btn btn-primary pull-left"
                  @click="createItem()"
                >
                  <span>&#43;</span>Request
                </button>
                <div class="pl-30 pull-left">
                  <h2>
                    Refund Request <span><i class="ic-corporate-card"></i></span>
                  </h2>
                  <!-- <p>Manage your corporate fund deposits</p> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <div class="dataTables_filter">
              <i class="ic-search"></i>
              <input
                type="search"
                class="form-control"
                v-model="table.keyword"
                @keyup="onKeyupKeyword()"
                placeholder="Search"
              />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="dataTables_length pull-right">
              <label>
                <select
                  class="form-control v-select"
                  v-model="table.pageSize"
                  @change="onChangePageSize()"
                >
                  <option v-for="item in table.pageSizes" :value="item" :key="item">
                    {{ item }}
                  </option>
                </select>
                Entries
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="table-responsive table-accordion table-p15">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>Requested Date</th>
                  <th>Requested By</th>
                  <th>Reservation Code</th>
                  <th>Company</th>
                  <th class="text-right">Requested Amount</th>
                  <th class="text-center">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr class="detail-row" v-for="item in items" :key="item.id">
                  <td>{{ printDate(item.requestedDate) }}</td>
                  <td>{{ item.requestedBy }}</td>
                  <td class="pos-rel">
                    <span :class="{ 'sts-danger': !item.hasReservation }">{{
                      item.hasReservation ? item.productReservationCode : "N/A"
                    }}</span>
                    <div
                      v-if="
                        item.hasAttachment ||
                        item.hasReservation ||
                        (item.status === 'RefundRequested' &&
                          (isAllowToOpenAttachment || isAllowToCancel))
                      "
                      class="row-big-menu"
                    >
                      <ul>
                        <li v-if="item.hasAttachment && isAllowToOpenAttachment">
                          <button
                            v-if="item.hasAttachment"
                            class="btn btn-default"
                            type="button"
                            @click="viewAttachment(item.id)"
                          >
                            <span>View Attch.</span>
                          </button>
                        </li>
                        <li v-if="item.hasReservation">
                          <button
                            class="btn btn-default --green35"
                            type="button"
                            @click="
                              viewReservation(item.subProduct, item.productReservationId)
                            "
                          >
                            <span>View Rsv.</span>
                          </button>
                        </li>
                        <li v-if="isAllowToCancel && notFromTransaction(item)">
                          <button
                            class="btn btn-default sts-danger"
                            type="button"
                            @click="openCancellationDialog(item.id)"
                          >
                            <span>Cancel</span>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </td>
                  <td>{{ item.companyName }}</td>
                  <td class="text-right">
                    {{ item.currencyCode }}
                    {{ printMoney(item.amount, item.moneyFormat) }}
                    <span
                      v-if="item.equivalentCurrencyCode"
                      class="equiv-deposit new-line"
                    >
                      ({{ item.equivalentCurrencyCode }}
                      {{ printMoney(item.equivalentAmount, item.moneyFormat) }})
                    </span>
                  </td>
                  <td class="text-center">{{ humanize(item.status) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_info --blue25">
              <strong>{{ recordInfo }}</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="table.pageNumber"
                :page-count="table.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="refunddepositmodal">
      <div class="modal-dialog modal-sm">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-new">
            <div class="row">
              <div class="col-sm-10">
                <h4>Refund Finances</h4>
                <h6 v-if="model.modifiedDate">
                  Last Updated: {{ model.modifiedDate.stringFullDate }}
                </h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <div class="summary-error" v-if="$v.model.$error">
                    This form has errors
                  </div>
                  <form @submit.prevent="submitRefund">
                    <div class="form-group">
                      <label class="required">Company</label>
                      <v-select
                        class="v-search-select"
                        :class="{
                          'field-error': isSubmitted && $v.model.companyId.$error,
                        }"
                        placeholder=""
                        label="name"
                        v-model="model.companyId"
                        :options="companies"
                        :clearable="true"
                        :searchable="true"
                        :filterable="true"
                        :reduce="(option) => option.id"
                        @input="onChangeCompany(model.companyId)"
                      ></v-select>
                      <small
                        class="form-text sts-danger"
                        v-if="isSubmitted && !$v.model.companyId.required"
                        >Company is required</small
                      >
                    </div>
                    <div class="row">
                      <div class="col-sm-4 prz">
                        <div class="form-group">
                          <label class="required">Currency</label>
                          <input
                            type="text"
                            class="form-control"
                            :class="{
                              'field-error': isSubmitted && $v.model.currencyCode.$error,
                            }"
                            v-model="model.currencyCode"
                            disabled
                          />
                          <small
                            class="form-text sts-danger"
                            v-if="isSubmitted && !$v.model.currencyCode.required"
                            >Currency is required</small
                          >
                        </div>
                      </div>
                      <div class="col-sm-8">
                        <div class="form-group">
                          <label class="required">Amount</label>
                          <currency-input
                            class="form-control"
                            :class="{
                              'field-error': isSubmitted && $v.model.amount.$error,
                            }"
                            autocomplete="off"
                            placeholder="Enter amount"
                            v-model="model.amount"
                            :allow-negative="false"
                            :currency="null"
                            :locale="currencyLocale"
                            :precision="currencyPrecision"
                          />
                          <div v-if="isSubmitted && $v.model.amount.$error">
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.amount.required"
                              >Amount is required</small
                            >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.amount.minValue"
                              >Min amount is
                              {{ $v.model.amount.$params.minValue.min }}</small
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="required">Description</label>
                      <textarea
                        class="form-control"
                        :class="{
                          'field-error': isSubmitted && $v.model.description.$error,
                        }"
                        rows="4"
                        name="description"
                        v-model="model.description"
                      ></textarea>
                      <div class="text-right word-count" v-if="model.description">
                        {{ model.description.length }} &#47;
                        {{ $v.model.description.$params.maxLength.max }}
                        characters
                      </div>
                      <div v-if="isSubmitted && $v.model.description.$error">
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.model.description.required"
                          >Description is required</small
                        >
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.model.description.maxLength"
                          >Description must be less than
                          {{ $v.model.description.$params.maxLength.max }}
                          characters</small
                        >
                      </div>
                    </div>
                    <div class="mb-15">
                      <label class="custom-file-label" for="customFile"
                        >Attach Document</label
                      >
                      <input
                        id="deposit-document"
                        class="custom-file-input input-uploader"
                        type="file"
                        name="image"
                        accept="image/jpeg,image/png,application/pdf"
                        v-on:change="onChangeDocument($event.target.files)"
                      />
                    </div>
                    <div class="modal-footer">
                      <button type="submit" class="btn btn-primary">Save</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <confirmModal
      :header="'Finance'"
      :content="'Are you sure you want to cancel this request?'"
      :cancel-label="'No'"
      :submit-label="'Yes'"
      @submit="cancel"
    />
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required, minValue, maxLength } from "vuelidate/lib/validators";
import numeral from "numeral";
import confirmModal from "@/components/shared/ConfirmModal";
import deleteModal from "@/components/shared/DeleteModal";
import depositRefundService from "@/services/master/deposit/depositRefundService.js";
import companyService from "@/services/master/company/companyService.js";

export default {
  components: {
    confirmModal,
    deleteModal,
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToOpenAttachment: function () {
      return this.allPermissions.includes("ViewDocument");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Demand");
    },
    isAllowToCancel: function () {
      return this.allPermissions.includes("Cancel");
    },
    recordInfo: function () {
      return this.table.totalRecords > 1
        ? `${this.table.totalRecords} Records`
        : `${this.table.totalRecords} Record`;
    },
  },
  data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
      },
      isSubmitted: false,
      currencyLocale: "en-US",
      currencyPrecision: 2,
      allPermissions: [],
      document: null,
      companies: [],
      cancelledId: null,
      defaultCompanyId: null,
      items: [],
      model: {},
      isLoading: false,
      msg: "Please wait",
    };
  },
  validations() {
    return {
      model: {
        companyId: { required },
        currencyCode: { required },
        amount: { required, minValue: minValue(0) },
        description: { required, maxLength: maxLength(500) },
      },
    };
  },
  async created() {
    this.$helper.scrollTop();
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.table.pageSize = this.$helper.extractSetting(publicSettings, "PageSize", 25);

    const profile = await this.$store.dispatch("user/getProfile");
    const permissions = profile.services["DepositRefund"];
    if (permissions) {
      this.allPermissions = permissions;
    }

    if (this.isAllowToRead) {
      await this.getAll();
      await this.getCompanies();

      if (profile.defaultCompany && this.companies && this.companies.length > 0) {
        const company = this.companies.find((x) => x.id == profile.defaultCompany.id);
        if (company) {
          this.defaultCompanyId = company.id;
        }
      }
    }
  },
  mounted() {
    $(this.$refs.refunddepositmodal).on("hidden.bs.modal", this.closeRefundDepositModal);
  },
  updated() {
    this.$helper.collapseMenu("deposit");
    this.$helper.setNavigationClass("refund-deposit-demand-link");
  },
  methods: {
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.getAll();
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.getAll();
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getAll();
    },
    resetTable() {
      this.table.keyword = "";
      this.table.pageNumber = 1;
      this.table.pageSize = 5;
    },
    resetModel() {
      document.getElementById("deposit-document").value = "";
      this.document = null;
      this.model = {};
    },
    resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    openDepositModal(object) {
      this.resetModel();
      this.resetValidations();
      this.model = Object.assign({}, object);
      $(this.$refs.refunddepositmodal).modal({ backdrop: "static", keyboard: false });
    },
    closeRefundDepositModal() {
      this.resetModel();
      this.resetValidations();
      $(this.$refs.refunddepositmodal).modal("hide");
    },
    createItem() {
      this.resetModel();
      this.openDepositModal({ companyId: this.defaultCompanyId, currencyCode: null });
      this.onChangeCompany(this.defaultCompanyId);
    },
    onChangeCompany(id) {
      const company = this.companies.find((x) => x.id === id);
      if (company) {
        this.model.currencyCode = company.preferredCurrencyCode;
      } else {
        this.model.currencyCode = null;
      }

      // update locale and precision plugin
      this.currencyLocale =
        this.model.currencyCode && this.model.currencyCode === "IDR" ? "id-ID" : "en-US";
      this.currencyPrecision =
        this.model.currencyCode && this.model.currencyCode === "IDR" ? 0 : 2;
    },
    onChangeDocument(files) {
      const maxSize = 4 * 1024 * 1024;
      if (files[0].size > maxSize) {
        this.document = null;
        document.getElementById("deposit-document").value = "";
        alert(`File is too big, max-size is  ${parseInt(maxSize / 1000000)}MB.`);
        return;
      }
      const fileExt = files[0].name
        .substring(files[0].name.lastIndexOf(".") + 1)
        .toLowerCase();
      if (!["jpeg", "jpg", "png", "pdf"].includes(fileExt)) {
        this.document = null;
        document.getElementById("deposit-document").value = "";
        alert("Invalid file type.");
        return;
      }
      this.document = files[0];
    },
    async getAll() {
      if (!this.isAllowToRead) {
        return;
      }
      try {
        this.isLoading = true;
        let filter = `?page=${this.table.pageNumber}&size=${this.table.pageSize}`;
        if (this.table.keyword !== null && this.table.keyword !== "") {
          filter += `&search=${this.table.keyword}`;
        }
        const response = await depositRefundService.getAllDemands(filter);
        this.items = response.data;
        this.table.totalPages = response.totalPages;
        this.table.totalRecords = response.totalRecords;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getCompanies() {
      this.companies = await companyService.getAllActive();
    },
    async submitRefund() {
      this.isSubmitted = true;
      this.$v.model.$touch();
      if (this.$v.model.$error) {
        return;
      }
      try {
        this.isLoading = true;
        delete this.model.minimumBalance;
        this.model.amount = parseFloat(this.model.amount);
        const response = await depositRefundService.demand(this.model);
        await this.uploadDocument(response.data);
        this.$notification.success("Successfully added.", { title: "Success" });
        await this.getAll();
        this.closeRefundDepositModal();
        this.resetTable();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async uploadDocument(demandDepositId) {
      if (this.document !== undefined && this.document !== null && this.document !== "") {
        let model = {
          id: demandDepositId,
        };
        const formData = new FormData();
        for (const key in model) {
          if (model.hasOwnProperty(key)) {
            formData.append(key, model[key]);
          }
        }
        formData.append(this.document.name, this.document);
        await depositRefundService.attach(formData);
      }
    },
    async viewAttachment(id) {
      try {
        this.isLoading = true;
        const response = await depositRefundService.viewAttachment(id);
        window.open(response.data, "_blank");
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    openCancellationDialog(id) {
      this.cancelledId = id;
      $("#confirmmodal").modal({ backdrop: "static", keyboard: false });
    },
    async cancel() {
      try {
        this.isLoading = true;
        await depositRefundService.cancel({
          id: this.cancelledId,
        });
        this.$notification.success("Successfully canceled.", { title: "Success" });
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    viewReservation(productType, id) {
      let routeData = null;
      switch (productType.toLowerCase()) {
        case "inquiry":
          routeData = this.$router.resolve({
            path: `/reservation/inquiry/${id}`,
          });
          break;
        case "instant":
          routeData = this.$router.resolve({
            path: `/reservation/instant/${id}`,
          });
          break;
      }
      window.open(routeData.href, "_blank");
    },
    printMoney(value, moneyFormat) {
      return numeral(value).format(moneyFormat.decimalFormat);
    },
    printDate(item) {
      return `${item.year}-${item.stringMonth}-${item.stringDate} ${item.stringHour}:${item.stringMinute}`;
    },
    humanize(value) {
      return (value && value !== '')
        ? this.$helper.humanize(value).replace('Topup', 'Top-up')
        : this.$helper.humanize(value);
    },
    notFromTransaction(item) {
      return item.productReservationCode === null;
    },
  },
};
</script>

<style scoped>
.detail-row td {
  height: 55px;
}
</style>



// WEBPACK FOOTER //
// src/components/deposit/refund/DepositRefundDemand.vue